import countryList from './isoCountryList.json';

const isoCountryList = countryList.reduce((list, country) => {
  const { name } = country;
  if (name) list.push({ ...country, label: name, value: name });
  return list;
}, []);

export default isoCountryList;
